/**
 * GlobalFeatures - Features showcase with image
 */
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';

const GlobalFeatures = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-muted/30 to-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 to-teal-500/20 rounded-3xl blur-3xl" />
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_global-exchange-28/artifacts/cd45bqs9_PARACHPAY%20five_students_money_transfer.webp"
              alt="Students making transfers with ParachPay"
              className="relative rounded-3xl shadow-2xl w-full h-auto object-cover"
            />
          </div>

          {/* Right Side - Text Content */}
          <div className="space-y-8 relative">
            <p className="text-lg text-muted-foreground leading-relaxed">
              {t('notices.globalIntro')}
            </p>

            <div className="space-y-6">
              <div className="p-5 rounded-xl bg-card border border-border hover:shadow-md transition-shadow">
                <h3 className="font-heading font-semibold text-lg mb-2">{t('landing.manageDashboard')}</h3>
                <p className="text-muted-foreground">{t('landing.manageWithoutComplexity')}</p>
              </div>

              <Link to="/register" className="block">
                <div className="p-5 rounded-xl bg-card border border-border hover:shadow-md hover:border-emerald-500/50 transition-all cursor-pointer group">
                  <h3 className="font-heading font-semibold text-lg mb-2 group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors">
                    {t('landing.sendReceiveMoney')}
                  </h3>
                  <p className="text-muted-foreground">
                    {t('landing.sendReceiveDesc')}
                  </p>
                </div>
              </Link>

              <div className="p-5 rounded-xl bg-card border border-border hover:shadow-md transition-shadow">
                <h3 className="font-heading font-semibold text-lg mb-2">{t('landing.requestMoney')}</h3>
                <p className="text-muted-foreground">{t('landing.requestMoneyDesc')}</p>
              </div>

              <div className="p-5 rounded-xl bg-card border border-border hover:shadow-md transition-shadow">
                <h3 className="font-heading font-semibold text-lg mb-2">{t('landing.myCurrencyWallets')}</h3>
                <p className="text-muted-foreground">{t('landing.myCurrencyWalletsDesc')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalFeatures;
